import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ActivePowerChart from "../components/ActivePowerChart";
import ActivePowerReportDialog from "../components/ActivePowerReportDialog";


function breakLargeGaps(data, maxGapMs = 60 * 60 * 1000) {
  if (!data.length) return [];
  const result = [data[0]];
  for (let i = 1; i < data.length; i++) {
    const prev = data[i - 1];
    const curr = data[i];
    const gap = curr.time - prev.time;
    if (gap > maxGapMs) {
      result.push({
        time: prev.time + 1,
        Pmean1: null,
        Pmean2: null,
        Pmean3: null,
        PTotalImport: null,
        PTotalExport: null,
      });
      result.push({
        time: curr.time - 1,
        Pmean1: null,
        Pmean2: null,
        Pmean3: null,
        PTotalImport: null,
        PTotalExport: null,
      });
    }
    result.push(curr);
  }
  return result;
}

export default function ActivePowerPage({ deviceType = "analyzer" }) {
  const { t } = useTranslation();
  const { deviceId } = useParams();

  const saved = JSON.parse(localStorage.getItem("selectedDevice") || "{}");
  const isVirtual = saved.mode === "virtual";
  const targetId = isVirtual ? saved.virtualId : deviceId;


  const [data, setData] = useState([]);
  const [range, setRange] = useState("1D");
  const [daily, setDaily] = useState(null);
  const [reportOpen, setReportOpen] = useState(false);

  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const API_BASE = process.env.REACT_APP_API_BASE_URL;

  const ENDPOINT_PREFIX = isVirtual
    ? "/virtual"
    : deviceType === "gruparge"
      ? "/gruparge"
      : deviceType === "reactive"
        ? "/reactive"
        : "/measurements";

  function getRangeMs(r) {
    switch (r) {
      case "1H": return 1 * 60 * 60 * 1000;
      case "3H": return 3 * 60 * 60 * 1000;
      case "6H": return 6 * 60 * 60 * 1000;
      case "12H": return 12 * 60 * 60 * 1000;
      case "1D": return 1 * 24 * 60 * 60 * 1000;
      case "3D": return 3 * 24 * 60 * 60 * 1000;
      case "1W": return 7 * 24 * 60 * 60 * 1000;
      default: return 1 * 24 * 60 * 60 * 1000;
    }
  }

  async function fetchData() {
    try {

      const end = new Date();
      const start = new Date(end.getTime() - getRangeMs(range));

      const url = `${API_BASE}${ENDPOINT_PREFIX}/active-power?deviceId=${targetId}&start=${start.toISOString()}&end=${end.toISOString()}`;
      const res = await fetch(url);
      const rows = await res.json();


      const formatted = rows.map((r) => ({
        time: new Date(r.time).getTime(),   // 🔥 ZORUNLU
        Pmean1: r.Pmean1,
        Pmean2: r.Pmean2,
        Pmean3: r.Pmean3,
        PTotalImport: r.PTotalImport,
        PTotalExport: r.PTotalExport,
      }));

      setData(breakLargeGaps(formatted));
    } catch (err) {
      console.error("fetchData error:", err);
    }
  }

  async function fetchDaily(date = selectedDate) {
    try {
      if (isVirtual) return;
      const today = new Date().toISOString().split("T")[0];
      const url = `${API_BASE}${ENDPOINT_PREFIX}/daily-consumption?deviceId=${deviceId}&date=${date}`;
      const res = await fetch(url);
      const json = await res.json();

      setDaily(json);
    } catch (err) {
      console.error("fetchDaily error:", err);
    }
  }

  useEffect(() => {
    if (!targetId) return;
    fetchData();
    fetchDaily();
    const i = setInterval(() => {
      fetchData();
      fetchDaily();
    }, 5000);
    return () => clearInterval(i);
  }, [API_BASE, deviceId, range]);






  return (
    <div className="p-4 md:p-6 grid grid-cols-1 gap-6">
      {/* Günlük tüketim kartları */}
      {/*!isVirtual && daily && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="bg-white rounded-2xl shadow-md p-4">
            <h3 className="text-sm font-medium text-gray-500">Günlük Import</h3>
            <p className="text-2xl font-bold text-gray-800">
              {daily?.dailyImport != null ? `${daily.dailyImport.toFixed(2)} kWh` : "-"}
            </p>
          </div>
          <div className="bg-white rounded-2xl shadow-md p-4">
            <h3 className="text-sm font-medium text-gray-500">Günlük Export</h3>
            <p className="text-2xl font-bold text-gray-800">
              {daily?.dailyExport != null ? `${daily.dailyExport.toFixed(2)} kWh` : "-"}
            </p>
          </div>
        </div>

      )*/}

      {/* Grafik */}
      <div className="bg-white rounded-2xl shadow-md p-4 md:p-6 flex flex-col">
        <h2 className="text-lg font-semibold text-gray-800 mb-4">{t('activePower.title')}</h2>
        <ActivePowerChart
          data={data}
          range={range}
          onRangeChange={setRange}
          isVirtual={isVirtual}
          deviceType={deviceType}
        />
      </div>

      {/* Günlük tüketim geçmişi (takvim tabanlı) */}
      {/*
  {!isVirtual && (
    <div className="bg-white rounded-2xl shadow-md p-4 mt-6">
      <h3 className="text-lg font-semibold text-gray-800 mb-4">
        Günlük Tüketim Geçmişi
      </h3>

      <input
        type="date"
        value={selectedDate}               
        className="border rounded-md px-3 py-2 text-sm"
        onChange={(e) => {
          const newDate = e.target.value;
          setSelectedDate(newDate);
          fetchDaily(newDate);
          e.target.blur();
        }}
      />

      {daily && (
        <div className="mt-4 grid grid-cols-2 gap-4">
          <div className="bg-gray-50 p-4 rounded-md text-center">
            <h4 className="text-sm text-gray-500">Import</h4>
            <p className="text-lg font-bold text-green-600">
              {daily.dailyImport != null ? `${daily.dailyImport.toFixed(2)} kWh` : "-"}
            </p>
          </div>

          <div className="bg-gray-50 p-4 rounded-md text-center">
            <h4 className="text-sm text-gray-500">Export</h4>
            <p className="text-lg font-bold text-red-600">
              {daily.dailyExport != null ? `${daily.dailyExport.toFixed(2)} kWh` : "-"}
            </p>
          </div>
        </div>
      )}
    </div>
  )}
*/}

      {/* Raporla butonu */}
      <div className="flex items-center justify-start mb-2">
        <button
          onClick={() => setReportOpen(true)}
          className="bg-sky-600 text-white px-3 py-2 rounded-md hover:bg-sky-700 text-sm"
        >
          {t('activePower.reportButton')}
        </button>
      </div>

      <ActivePowerReportDialog
        open={reportOpen}
        onClose={() => setReportOpen(false)}
        deviceId={targetId}
        deviceType={deviceType}
        API_BASE={API_BASE}
        isVirtual={isVirtual}
      />
    </div>
  );
}
